import { render, staticRenderFns } from "./CommonSwitchFilterGroup.vue?vue&type=template&id=2239ff3b"
import script from "./CommonSwitchFilterGroup.vue?vue&type=script&lang=js"
export * from "./CommonSwitchFilterGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports